import React from 'react';
import { Link } from 'react-router-dom';

const ButtonComponent = (props) => {
  if (props.href && props.href !== "#") {
    return (
      <Link to={props.href}>
        <button
          className={`h-[35px] ${props.icon ? 'flex' : 'flex'} items-center justify-center ${props.id} transition duration-75 text-sm min-w-24 ${props.bgcolor} d p-2`}
          onClick={props.onClick} 
        >
          {props.icon} {props.title}
        </button>
      </Link>
    );
  }
  
  return (
    <button
      className={`h-[35px] ${props.icon ? 'flex' : 'flex'} items-center justify-center ${props.id} transition duration-75 text-sm min-w-24 ${props.bgcolor} shadow-md d p-2`}
      onClick={props.onClick} 
    >
      {props.icon} {props.title}
    </button>
  );
}

export default ButtonComponent
